export default __webpack_public_path__ + "static/media/Modern.81cc3c7d.jpg";